import { localize } from '@oneflowab/pomes';
import type { ElementType } from 'react';
import type { MessageTranslator } from '@oneflowab/pomes';

import { getDurationTypesAsOptions } from '@flow/libs/agreement/duration';

import {
  Select,
  SelectContent,
  SelectIcon,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@app/components/select-compound';

import BoxEmptyDraftStateRaw from '../box-empty-draft-state-raw';
import style from './box-empty-draft-state-duration.module.scss';

type Props = {
  icon: ElementType;
  message: MessageTranslator;
  onChange: () => void;
};

const BoxEmptyDraftState = ({ icon, message, onChange }: Props) => (
  <BoxEmptyDraftStateRaw
    icon={icon}
    mainAction={
      <Select onValueChange={onChange}>
        <SelectTrigger
          id="durationType"
          className={style.SelectTrigger}
        >
          <SelectValue
            placeholder={message({
              id: 'Select duration type',
              comment: 'Placeholder for duration type selection.',
            })}
          />
          <SelectIcon />
        </SelectTrigger>
        <SelectContent>
          {getDurationTypesAsOptions(message).map((option) => (
            <SelectItem
              key={option.value}
              value={option.value}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    }
  />
);

export const BoxEmptyDraftStateDuration = localize<Props>(BoxEmptyDraftState);
